import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import { limitParagraphByCharLimit } from "../../Helper/Helper";
import { useSelector } from "react-redux";

function DoctorHomeIntro() {
  const [homeIntroData, setHomeIntroData] = useState({});
  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    getHomeIntroData();
  }, []);

  const getHomeIntroData = async () => {
    const response = await SendPostRequest("content/aboutus");
    setHomeIntroData(response?.data);
  };

  const options = {
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 2500,
    autoplayHoverPause: true,
    smartSpeed: 1000,
    margin: 30,
    responsive: {
      0: { items: 1 },
    },
  };

  return (
    <section id="section-about" className="section-about pt-0 pb-0 mb-0">
      <div className="container">
        <div className="row my-3">
          {homeIntroData &&
            (homeIntroData?.who_we_are_video ||
              homeIntroData?.who_we_are_description) && (
              <>
                <div className="col-lg-6 col-md-12 col-12 pt-5 classic-who-we-are">
                  <div
                    className="about-vedio-frame w-100"
                    dangerouslySetInnerHTML={{
                      __html: homeIntroData?.who_we_are_video?.replace(
                        /src="([^"]+)"/,
                        (match, p1) => {
                          const newUrl = new URL(p1);
                          newUrl.searchParams.set("autoplay", "1");
                          newUrl.searchParams.set("mute", "1");
                          newUrl.searchParams.set("rel", "0");
                          
                          return `src="${newUrl.toString()}"`;
                        }
                      ),
                    }}
                  />
                </div>
                <div className="col-lg-6 col-md-12 col-12 pt-5">
                  <div className="title-wrap relative mb-3">
                    <div className="section-title margin-bottom-25 animated fadeInDown visible">
                      <h2 className="section-title mb-0 text-uppercase">
                           {homeIntroData?.who_we_are_heading || (
                          <>
                            Who We Are<span className="theme-color"></span>
                          </>
                        )}
                      </h2>
                      <span className="section-border-bottom"></span>
                    </div>
                    <div className="pad-top-15">
                      <p className="mb-0">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: homeIntroData?.who_we_are_description,
                          }}
                        ></span>
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}
        </div>
      </div>
    </section>
  );
}

export default DoctorHomeIntro;
